export default __webpack_public_path__ + "static/media/contact.613d01aa.svg";